import React, { useState, useEffect } from "react";
import SiteLogo from "./SiteLogo";
import { useTranslation } from "src/_common/hooks/useTranslation";
import { useAppUserDataSelector } from "src/_common/hooks/selectors/userSelector";

interface HeaderProps {
    variant?: "default" | "topbar";
}

export default function Header({ variant = "default" }: HeaderProps) {
    const { changeLanguage } = useTranslation();
    const userData = useAppUserDataSelector();
    const [language, setLanguage] = useState("EN");
    const [showInfoBar, setShowInfoBar] = useState(false);

    // Initialize language from localStorage or default to EN
    useEffect(() => {
        const savedLanguage = localStorage.getItem('selectedLanguage') || 'EN';
        setLanguage(savedLanguage);
    }, []);

    // Show info bar only if subscription has_plan is false
    useEffect(() => {
        if (userData && userData.subscription && userData.subscription.has_plan === false) {
            setShowInfoBar(true);
        } else {
            setShowInfoBar(false);
        }
    }, [userData]);

    const languages = [
        { code: "EN", name: "English" },
        { code: "AR", name: "Arabic" },
        { code: "FR", name: "Français" },
        { code: "ES", name: "Español" },
        { code: "HI", name: "हिन्दी" },
    ];

    if (variant === "topbar") {
        return (
            <>
                {/* Informational Overlay Bar */}
                {showInfoBar && (
                    <div className="info-overlay-bar">
                        <div className="info-overlay-content">
                            <span className="info-overlay-text">
                               Please buy a plan, to continue using our services.
                            </span>
                            <button 
                                className="info-overlay-close" 
                                onClick={() => setShowInfoBar(false)}
                                aria-label="Close"
                            >
                                ×
                            </button>
                        </div>
                    </div>
                )}
                
                <header className="drjob-header">
                    <div className="drjob-header-container">
                    {/* Header Actions */}
                    <div className="drjob-header-actions">
                        {/* Language Selector */}
                        <div className="drjob-language-selector">
                            <select
                                value={language}
                                onChange={(e) => {
                                    const selectedLang = e.target.value;
                                    setLanguage(selectedLang);
                                    // Add direction change for Arabic
                                    document.documentElement.dir = selectedLang === 'AR' ? 'rtl' : 'ltr';
                                    document.documentElement.lang = selectedLang.toLowerCase();
                                    // Use the translation hook's changeLanguage function
                                    changeLanguage(selectedLang);
                                }}
                                className="drjob-language-select"
                            >
                                {languages.map((lang) => (
                                    <option key={lang.code} value={lang.code}>
                                        {lang.code}
                                    </option>
                                ))}
                            </select>
                        </div>

                       
                    </div>
                </div>
            </header>
            </>
        );
    }

    // Default header for other pages (could be empty or basic logo)
    return (
        <header className="default-header">
            <SiteLogo className="medium-logo" />
        </header>
    );
}
